import React from 'react';
import { FooterLinks } from '../templates/sections/FooterLinks';
import { FooterUtility } from '../templates/sections/FooterUtility';

const Footer = (props) => {
  const { page, sanity } = props;

  return (
    <footer id="footer">
      <FooterLinks page={page} sanity={sanity} />
      <FooterUtility page={page} sanity={sanity} />
    </footer>
  );
};

export { Footer };
